<div class="modal-content">
  <div class="modal__content">
    <div class="modal__header">
      <a *ngIf="showReturnArrow" (click)="returnArrowClick()">Volver</a>
      <h3 *ngIf="!modifiedVehicle" class="h3 modal__title">
        {{ 'sharedModule.bkgVehicleDialog.addVehicle' | translate }}
      </h3>
      <h3 *ngIf="modifiedVehicle" class="h3 modal__title">
        {{ 'sharedModule.bkgVehicleDialog.editVehicle' | translate }}
      </h3>
      <button
        (click)="onClickClose()"
        type="button"
        class="modal__close"
        data-bs-dismiss="modal"
        attr.aria-label="{{ 'common.close' | translate }}"
      >
        <img src="assets/images/icons/close.svg" alt="" />
      </button>
    </div>

    <div class="modal__body">
      <bkg-dialog-banner
        [isVisible]="!!errorMessage"
        [message]="errorMessage"
        (closeBanner)="onCloseBanner()"
      >
      </bkg-dialog-banner>

      <ng-container *ngIf="selectClientCarView">
        <bkg-vehicle-dialog-select-client-car
          (selectedVehicleReturn)="onSelectedVehicle($event)"
          (errorReturn)="onError($event)"
          (addNewVehicleViewReturn)="onClickAddNewVehicle($event)"
          [addMoreInfoClient]="addMoreInfoClient"
          [clientId]="clientId"
        ></bkg-vehicle-dialog-select-client-car>
      </ng-container>

      <ng-container *ngIf="addLicensePlateView">
        <bkg-vehicle-dialog-license-plate
          (newVehicleReturn)="onSelectedVehicle($event)"
          (errorReturn)="onError($event)"
          (addNewVehicleViewReturn)="onClickAddNewVehicle($event)"
          (showUmcSelectorsReturn)="onClickShowUmcSelectors($event)"
          (plateNotFoundedReturn)="onPlateNotFoundedReturn($event)"
          (vehicleNotFoundedReturn)="onVehicleNotFoundedReturn($event)"
          [isLogged]="isLogged"
          [addMoreInfoLicense]="addMoreInfoLicense"
          [clientId]="clientId"
        ></bkg-vehicle-dialog-license-plate>
      </ng-container>

      <ng-container *ngIf="umcSelectorView">
        <bkg-vehicle-dialog-umc-selectors
          [vehicleId]="vehicleData.id"
          [isLogged]="isLogged"
          [createNewVehicle]="createNewVehicle"
          [plateNotFounded]="plateNotFounded"
          [notFoundedVehicleID]="notFoundedVehicleID"
          (umcSelectorsReturn)="onSelectedVehicle($event)"
          (notFoundCarOptionReturn)="onClickNotFoundCarOption($event)"
          (errorReturn)="onError($event)"
          [addMoreInfoUmc]="addMoreInfoUmc"
          [clientId]="clientId"
          [modifiedVehicle]="modifiedVehicle"
        ></bkg-vehicle-dialog-umc-selectors>
      </ng-container>

      <ng-container *ngIf="umcDataSelectorsView">
        <bkg-vehicle-dialog-umc-data-selectors
          [vehicleId]="vehicleData.id"
          [umc]="vehicleData.umc"
          [umcData]="vehicleData.umcData"
          [isLogged]="isLogged"
          [clientId]="clientId"
          (umcDataSelectorsReturn)="onSelectedVehicle($event)"
          (notFoundCarOptionReturn)="onClickNotFoundCarOption($event)"
          (errorReturn)="onError($event)"
        ></bkg-vehicle-dialog-umc-data-selectors>
      </ng-container>

      <ng-container *ngIf="requestedDataView">
        <bkg-vehicle-dialog-requested-data
          (allRequestedReturn)="onCloseDialog($event)"
          (errorReturn)="onError($event)"
          [vehicleData]="vehicleData"
          [requestedCSData]="requestedCSData"
          [isLogged]="isLogged"
          [moreInfoShowing]="moreInfoShowing"
          [clientId]="clientId"
        >
        </bkg-vehicle-dialog-requested-data>
      </ng-container>

      <ng-container *ngIf="notFoundVehicleFormView">
        <bkg-vehicle-dialog-not-found-form
          [isLogged]="isLogged"
          (errorReturn)="onError($event)"
          (closeModalReturn)="onCloseDialog()"
        ></bkg-vehicle-dialog-not-found-form>
      </ng-container>
    </div>
  </div>
</div>
